import { Box, BoxProps } from '@chakra-ui/react'

export type { BoxProps }

export default Box
